import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { BREADCRUMB_LINKS } from '../constants/constants';

const BreadcrumComponent = (props) => {

    useEffect(() => {
        const item = document.getElementsByClassName('active');
        const b = document.getElementById('breadcrumb-container');
        if (item.length) {
            let active = item[0];
            let pos = active.getBoundingClientRect();
            b.scrollLeft += (pos.left - 50);
        }
    });

    return (<div className="breadcrumb">
        <div className="breadcrumb-container container" id="breadcrumb-container">
            <div className="breadcrumb-inner" id="breadcrumb-inner">
            {
                Object.keys(BREADCRUMB_LINKS).map(function (key, index) {
                    return (<div className="breadcrumb-item" key={BREADCRUMB_LINKS[key]['id']}>
                        {props.enabled.includes(key) ?
                            <Link
                                to={BREADCRUMB_LINKS[key]['link']}
                                className={document.location.pathname == BREADCRUMB_LINKS[key].link ? 'active' : ''}
                                onClick={() => {
                                    gaTrack('RB App', `Breadcrumb`, `Tab Name: ${BREADCRUMB_LINKS[key]['tab_name']}`);
                                    let ga_event = 'app_breadcrumb_' + (BREADCRUMB_LINKS[key]['tab_name']).replace(' ', '_');
                                    ga4Track(ga_event, 'RB App', `Tab Name: ${BREADCRUMB_LINKS[key]['tab_name']}`);
                                }
                                }
                            >
                                
                                {BREADCRUMB_LINKS[key]['tab_name']}

                            </Link> :
                            <>
                                
                                {BREADCRUMB_LINKS[key]['tab_name']}
                            </>}
                    </div>)
                })
            }
        </div>
        </div>
    </div>);
};

export default BreadcrumComponent;